import { OnInit, Component } from '@angular/core';
import { MenuStore } from '../../../menus/service/menu.store';
import { CompletedUnpaidDashboardStore } from '../../service/completed-unpaid-dashboard.store';
import { MissingAgencyDashboardStore } from '../../service/missing-agency-dashboard.store';
import { UserLocalStorageService } from '../../../permission/services/user.local.storage.service';
import { DashboardFilterState } from './dashboard-filter';
import { AuthenticationStore } from '../../../permission/services/authentication.store';
import { User } from '../../../auth/models/User';

@Component({
  selector: 'pioneer-dashboard',
  templateUrl: './dashboard.component.html'
})
export class DashboardComponent implements OnInit {

  showCompletedAndUnpaid: boolean;
  showMissingAgency: boolean;
  user: User;

  constructor(
    private menuStore: MenuStore,
    private completedUnpaidDashboardStore: CompletedUnpaidDashboardStore,
    private missingAgencyDashboardStore: MissingAgencyDashboardStore,
    private userLocalStorageService: UserLocalStorageService,
    private authenticationStore: AuthenticationStore
  ) {}

  ngOnInit(): void {
    this.menuStore.setPageTitle('DASHBOARD.TITLE');
    this.showCompletedAndUnpaid = true;
    this.showMissingAgency = true;
    this.completedUnpaidDashboardStore.loadTotals().subscribe();
    this.missingAgencyDashboardStore.loadTotals().subscribe();

    this.authenticationStore.user.subscribe((user: User) => {
      this.user = user;
    });

    this.completedUnpaidDashboardStore.showCard().subscribe(bool => {
      this.showCompletedAndUnpaid = bool;
    });

    this.missingAgencyDashboardStore.showCard().subscribe(bool => {
      this.showMissingAgency = bool;
    });
  }

  toggleShowCompletedAndUnpaid(): void {
    this.showCompletedAndUnpaid = !this.showCompletedAndUnpaid;
    this.saveDashboardStateToLocalStorage();
  }

  toggleShowMissingAgency(): void {
    this.showMissingAgency = !this.showMissingAgency;
    this.saveDashboardStateToLocalStorage();
  }

  private saveDashboardStateToLocalStorage() {
    const dashboardFilters = new DashboardFilterState({
      completedAndUnpaid: this.showCompletedAndUnpaid,
      missingAgency: this.showMissingAgency
    });
    const email = this.user.email;
    this.userLocalStorageService.setDashboardFilterState(email, dashboardFilters);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/dashboard/dashboard-page/dashboard.component.ts